import React, { useState } from "react";
import { Box, Tabs, Tab, Grid, Typography, Button, useTheme, useMediaQuery } from "@mui/material";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import ChangePassword from "../components/ChangePassword";
import Users from "../components/Users";
import Perfil from "../components/Perfil";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import OrderProduct from "../components/OrderProduct";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import DistribuidoresMaps from "../components/DistribuidoresMaps";

const styles = {
  root: {
    display: "flex",
    color: "Black",
    height: 450,
  },
  rootMobile: {
    display: "flex",
    flexDirection: "column",
    color: "Black",
  },
  tabs: {
    alignSelf: "center",
    borderRight: `1px solid ${"#f5f5f5"}`,
    flexGrow: 0.2,
    "&& .Mui-selected": { color: "black" },
  },
  tabsMobile: {
    width: "100%",
    borderRight: `1px solid ${"#f5f5f5"}`,
    borderLeft: `1px solid ${"#f5f5f5"}`,
    "&& .Mui-selected": { color: "black" },
  },
  what: {
    color: "#FFF",
    backgroundColor: "#25d366",
    "&:hover": { backgroundColor: "#21bd5b" },
    width: 42,
    height: 42,
    float: "right",
  },
  IconButton: {
    transition: "all 0.2s ease-in",
    "&:hover": { backgroundColor: "#9BCD65", color: "black" },
  },
};

function TabPanel(props) {
  const { children, value, index, isMapComponent = false, isMobile = false, ...other } = props;
  
  // Solo eliminar padding si es el componente de mapa Y es móvil
  const shouldRemovePadding = isMapComponent && isMobile;

  return (
    <div hidden={value !== index} {...other} style={{ flex: 30 }}>
      {value === index && (
        <Box p={shouldRemovePadding ? 0 : 2} m={shouldRemovePadding ? 0 : 1}>
          {children}
        </Box>
      )}
    </div>
  );
}
//
export default function Menu() {
  const { state } = useLocation();
  const { roles, salesData } = useSelector((state) => state.account);
  const navigate = useNavigate();
  const [value, setValue] = useState(state || 0);

  const theme = useTheme()
  const mobile = useMediaQuery(theme.breakpoints.down("md"))

  return (
    <>
      {Object.keys(salesData).length === 0 &&
        (roles.includes("Vendedor") || roles.includes("Admin Ventas")) && (
          <Box marginBottom={2}>
            <Button
              onClick={() => navigate("/products")}
              variant="outlined"
              sx={styles.IconButton}
              startIcon={<ChevronLeftIcon />}
            >
              Volver
            </Button>
          </Box>
        )}
      <div style={mobile ? styles.rootMobile : styles.root}>
        <Tabs
          centered
          orientation={mobile ? "horizontal" : "vertical"}
          indicatorColor="primary"
          variant="scrollable"
          sx={mobile ? styles.tabsMobile : styles.tabs}
          onChange={(event, newValue) => setValue(newValue)}
          value={value}
        >
          <Tab label="Perfil" icon={<GroupAddIcon />} />
          <Tab label="Usuarios" icon={<GroupAddIcon />} />
          <Tab label="Contraseña" icon={<AssignmentTurnedInIcon />} />
          {!roles.includes("Vendedor") && !roles.includes("Admin Ventas") && (
            <Tab label="Ordenes" icon={<ShoppingCartIcon />} />
          )}
          {/* <Tab label="Distribuidores" icon={<AssignmentTurnedInIcon />} /> */}
        </Tabs>
        <TabPanel value={value} index={0}>
          <Perfil />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <Users />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <ChangePassword />
        </TabPanel>
        <TabPanel value={value} index={3}>
          <Grid item xs={12} md={12}>
            <Typography variant="h5" align="center" gutterBottom>
              Ordenes
            </Typography>
          </Grid>
          <Grid item xs={12} md={12}>
            <OrderProduct />
          </Grid>
        </TabPanel>
        {/* <TabPanel value={value} index={4} isMapComponent={true} isMobile={mobile}>
          <DistribuidoresMaps />
        </TabPanel> */}
      </div>
    </>
  );
}
